import React from "react";

const Link2 = () => {
  return <div className="link-2">Link 2</div>;
};

export default Link2;
